module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.tema,
    attrs: {
      "id": "hotsite"
    }
  }, [_c('div', {
    staticClass: "placa"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "descricao"
  }, [_c('h3', [_vm._v(_vm._s(_vm.nome))])])])]), _c('div', {
    staticClass: "corpo"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-lg-9"
  }, [_c('hotsite-menu', {
    attrs: {
      "slot": "mobile",
      "links": _vm.menu
    },
    slot: "mobile"
  }), _c('breadcrumb', {
    staticClass: "hotsite",
    attrs: {
      "itens": _vm.breadcrumb
    }
  }), _vm._t("conteudo")], 2), _c('div', {
    staticClass: "col-md-4 col-lg-3 visible-md visible-lg"
  }, [_c('hotsite-aside', {
    attrs: {
      "slot": "sidebar",
      "links": _vm.menu
    },
    slot: "sidebar"
  })], 1)])])]), _c('div', {
    staticClass: "links"
  }, [_c('hotsite-links', {
    attrs: {
      "slot": "links",
      "links": _vm.links
    },
    slot: "links"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cd6ce9b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Hotsite.vue
// module id = 501
// module chunks = 0